(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('decodeUri', decodeUri);

    /** @ngInject */
    function decodeUri() {
        return function(text) {
            if (!text) {
                return text;
            }
            try {
                return decodeURIComponent(text);
            } catch (e) {
                return text;
            }
        };
    }

})();
